/* eslint no-param-reassign: ["off"] */
import angular from 'angular';


const MINUTES_IN_DAY = 480;
const DAYS_IN_WEEK = 5;

class Converter {
  constructor(minutesInDay, daysInWeek) {
    this.minutesInDay = minutesInDay;
    this.daysInWeek = daysInWeek;
  }

  toMinutes({ weeks = 0, days = 0, hours = 0, minutes = 0 }) {
    //return (((weeks * this.daysInWeek) + days) * this.minutesInDay) + 
    return (hours * 60) + minutes;
  }

  fromMinutes(minutes) {
    let hours = Math.floor(minutes / 60);
    minutes %= 60;
    /*
    let days = Math.floor((hours * 60) / this.minutesInDay);
    hours -= Math.floor((days * this.minutesInDay) / 60);

    const weeks = Math.floor(days / this.daysInWeek);
    days %= this.daysInWeek;
    */
    return { weeks:0, days:0, hours, minutes };
  }
}

class Formatter {
  constructor(mode, converter) {
    this.short = mode === 'hm';
    this.converter = converter;
  }

  format({ weeks = 0, days = 0, hours = 0, minutes = 0, invalid }, invalidValue = '') {
    if (invalid) return invalidValue;
    if (!weeks && !days && !hours && !minutes) return '0';
    if (this.short) {
      const totalMinutes = this.converter.toMinutes({ weeks, days, hours, minutes });
      hours = Math.floor(totalMinutes / 60);
      minutes %= 60;
      days = 0;
      weeks = 0;
    }
    const dateParts = [];
    if(weeks){
      dateParts.push(`${weeks}w`)
    }
    if(days){
      dateParts.push(`${days}d`)
    }
    if(hours){
      dateParts.push(`${hours}h`)
    }
    if(minutes){
      dateParts.push(`${minutes}m`)
    }
    return dateParts.join(' ');
  }

  parse(str) {
    if (/^\s*0\s*$/g.test(str)) return { weeks: 0, days: 0, hours: 0, minutes: 0 };
    const DURATION_REGEXP = this.short
      ? /^\s*((\d+)h\s*)?((\d+)m)?\s*$/g
      : /^\s*((\d+)w\s*)?((\d+)d\s*)?((\d+)h\s*)?((\d+)m)?\s*$/g;

    const match = DURATION_REGEXP.exec(str);
    if (!match) {
      return { invalid: true };
    }
    let model = {};
    if (this.short) {
      model = {
        weeks: 0,
        days: 0,
        hours: Number(match[2]) || 0,
        minutes: Number(match[4]) || 0,
      };
    } else {
      model = {
        weeks: Number(match[2]) || 0,
        days: Number(match[4]) || 0,
        hours: Number(match[6]) || 0,
        minutes: Number(match[8]) || 0,
      };
    }
    if (model.weeks > 10
      || model.days > 100
      || model.hours > 100
      || model.minutes > 1000) {
      return { invalid: true };
    }
    return model;
  }
}

const durationService = angular.module('ttb.services.duration.service', [])
  .factory('durationService', () => {
    function compare(d1, d2) {
      return d1.weeks === d2.weeks
        && d1.days === d2.days
        && d1.hours === d2.hours
        && d1.minutes === d2.minutes
        && d1.invalid === d2.invalid;
    }

    function isEmpty(duration) {
      if (!duration) return true;
      return !duration.weeks
        && !duration.days
        && !duration.hours
        && !duration.minutes
        && !duration.invalid;
    }

    function getConverter({ minutesInDay = MINUTES_IN_DAY, daysInWeek = DAYS_IN_WEEK } = {}) {
      return new Converter(minutesInDay, daysInWeek);
    }

    function getFormatter({ mode = 'wdhm', minutesInDay = MINUTES_IN_DAY, daysInWeek = DAYS_IN_WEEK } = {}) {
      return new Formatter(mode, getConverter(minutesInDay, daysInWeek));
    }

    return {
      compare,
      isEmpty,
      getConverter,
      getFormatter,
    };
  })
  .name;

export default durationService;



// WEBPACK FOOTER //
// ../services/duration.service.js